import { all } from 'redux-saga/effects'
import { rootSaga as userSagas } from './user/sagas'
import { rootSaga as themeSagas } from './theme/sagas'
import { rootSaga as hookSagas } from './hook/sagas'
import { rootSaga as profileSagas } from './profile/sagas'
import { rootSaga as paymentTemplateSaga } from './paymentTemplate/sagas'
import { rootSaga as statSaga } from './stats/sagas'
import { rootSaga as userChatSaga } from './userchat/sagas'
import { rootSaga as flowSagas } from './flow/sagas'

export function* rootSaga() {
  yield all([
    userSagas(),
    themeSagas(),
    hookSagas(),
    flowSagas(),
    profileSagas(),
    paymentTemplateSaga(),
    statSaga(),
    userChatSaga()
  ])
}
